import { RadioOption } from '@infoods/lifebase-ui';

export const scanOptions: RadioOption[] = [
  { label: 'All', value: '' },
  { label: 'Has Scans', value: true },
  { label: 'No Scans', value: false },
];
